module.exports = __webpack_public_path__ + "img/检品配置.c2542c3f.png";